
import ButtonCard from "@/components/ButtonCard.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import ListDefault from "@/components/ListDefault.vue";
import OptionCollapse from "@/components/OptionCollapse.vue";
import HomeContainer from "@/containers/HomeContainer.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import { VMoney } from "v-money";
import { Component, Vue } from "vue-property-decorator";

declare const fbq: any;

@Component({
  props: { dependentsData2: String },
  components: {
    ButtonCard,
    HeaderFluxo,
    ListDefault,
    OptionCollapse,
    VMoney,
    HomeContainer,
  },
})
export default class Carteira extends Vue {
  dependentsData: any = JSON.parse(
    sessionStorage.getItem("DEPENDENT_DATA") || "[]"
  );
  dependents: any = JSON.parse(sessionStorage.getItem("DEPENDENT") || "[]");
  hasDependents = false;
  hasUser = false;
  carteiraDependentes = true;
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");
  hasPixel: any = JSON.parse(sessionStorage.getItem("hasPixel") || "false");

  mounted() {
    if (this.hasPixel) {
      fbq("trackCustom", "viewWallet");
    }
    Util.setBackButtonBehavior(this.goBack);
    this.getWalletFromUserAndDependents();
    sessionStorage.setItem("DEPENDENT", JSON.stringify(this.dependentsData));
    sessionStorage.getItem("DEPENDENT");
    this.$router.push("Extrato");
  }

  getWalletFromUserAndDependents() {
    try {
      const req = new Request();
      const self = this;
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
      };
      req.route = "getWalletFromUserAndDependents";
      req.callbackSuccess = (response: any) => {
        if (response && response.dependentsData) {
          self.dependents = response.dependentsData;
          sessionStorage.setItem("DEPENDENT", JSON.stringify(self.dependents));
          sessionStorage.setItem(
            "DEPENDENT_DATA",
            JSON.stringify(response.dependentsData)
          );
        }
        this.dependentsData = response.dependentsData;
        this.hasDependents = true;
      };

      req.callbackError = (error: any) => {
        this.hasDependents = false;
        console.log(error);
      };
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  click(DEPENDENT_ID: any) {
    let dependent = this.dependentsData.find((d: any) => {
      return d.DEPENDENT_ID == DEPENDENT_ID;
    });
    sessionStorage.setItem("DEPENDENT_DATA2", JSON.stringify(dependent));
    this.$router.push("CarteiraUsuario");
  }

  data() {
    return {
      inputValues: {},
    };
  }

  goBack() {
    this.$router.push("HomeApp");
  }
}
